import service from '@/utils/server';

const modName='/bd/orderExport/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const unloadConfigExport = data => {
  let config = {
    responseType: "blob"
  };
  return service( {
    ...config,
    url: modName + 'unloadConfigExport',
    method: 'post',
    data
  });
};

//查询详情
export const getIntData = data => {
  return service({
    url: modName + 'detail',
    method: 'post',
    data
  });
};








// WEBPACK FOOTER //
// ./src/page/bd/accessory/orderExport/api/index.js